export default "__VITE_ASSET__2KvNrVz$__"